import { render, staticRenderFns } from "./SearchPopover.vue?vue&type=template&id=4f52a9bb"
import script from "./SearchPopover.vue?vue&type=script&lang=js"
export * from "./SearchPopover.vue?vue&type=script&lang=js"
import style0 from "./SearchPopover.vue?vue&type=style&index=0&id=4f52a9bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports